// src/features/documents/components/Documents/index.jsx
import React from 'react';
import useFetch from '../../../../shared/hooks/useFetch';
import { fetchSettings } from '../../../../api';
import DocumentBuilder from '../DocumentBuilder';
import LoadingSpinner  from '../../../../shared/components/ui/LoadingSpinner';
import PageHeader      from '../../../../shared/components/layout/PageHeader';

const Documents = () => {
  const { data: settings, loading } = useFetch(fetchSettings);
  if (loading) return <LoadingSpinner message="جاري التحميل..." />;
  return (
    <div>
      <PageHeader
        title="منشئ المستندات"
        subtitle="فواتير • عقود • أي مستند — تحرير مباشر على الورقة"
      />
      <DocumentBuilder settings={settings} />
    </div>
  );
};

export default Documents;